import React, {useState} from 'react';
import {View, Text, StyleSheet, TouchableOpacity} from 'react-native';
import Colors from '../../../assets/Color/Colors';
import RupeeVal from '../../../commonComponents/RupeeVal';
import {globalFontStyle} from '../../../assets';
import {globalConfigurableData} from '../../../utils/globalConstant';
import FormTextLabel from '../../../commonComponents/FormTextLabel';

const LiquidityFields = ({liquidity1}) => {
  let liquidity = liquidity1;

  const invested_Liq_Token_Count = liquidity.investedLiqTokenCount
    ? liquidity.investedLiqTokenCount
    : 0.0;
  const invested_Liq_Token_Price = liquidity.investedLiqTokenPrice
    ? liquidity.investedLiqTokenPrice
    : 0.0;
  const curr_Liq_Price = liquidity.currLiqPrice ? liquidity.currLiqPrice : 0.0;
  const trading_Fee_Liquidity_Tokens = liquidity.tradingFeeLiquidityTokens
    ? liquidity.tradingFeeLiquidityTokens
    : 0.0;

  return (
    <>
      <View style={styles.liquidityBlock}>
        <FormTextLabel
          labelStyles={{
            ...globalFontStyle.appFontSubText,
            color: globalConfigurableData.primaryTextColor1,
          }}
          label={'LIQUIDITY DETAILS'}
        />
      </View>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginTop: 10,
          paddingHorizontal: 15,
          //paddingVertical: 18,
        }}>
        <View style={[styles.rowCol, {alignItems: 'flex-start'}]}>
          <FormTextLabel labelStyles={styles.marginRow} label={'LP Shares'} />
          <Text style={styles.valText}>
            {invested_Liq_Token_Count.toFixed(2)}
          </Text>
        </View>
        <View style={[styles.rowCol, {alignItems: 'flex-start'}]}>
          <FormTextLabel
            labelStyles={styles.marginRow}
            label={'Initial Price'}
          />
          <RupeeVal
            customStyle={styles.valText}
            rupeeVal={invested_Liq_Token_Price.toFixed(2)}
          />
        </View>
        <View style={[styles.rowCol, {alignItems: 'flex-start'}]}>
          <FormTextLabel
            labelStyles={styles.marginRow}
            label={'Current Price'}
          />
          <RupeeVal
            customStyle={styles.valText}
            rupeeVal={curr_Liq_Price.toFixed(2)}
          />
        </View>
        <View style={[styles.rowCol, {alignItems: 'flex-start'}]}>
          <FormTextLabel labelStyles={styles.marginRow} label={'Fees Earned'} />
          <RupeeVal
            customStyle={styles.valText}
            rupeeVal={trading_Fee_Liquidity_Tokens.toFixed(2)}
          />
        </View>
      </View>
    </>
  );
};

export default LiquidityFields;

const styles = StyleSheet.create({
  rowCol: {
    flex: 1,
    flexBasis: 0,
    flexShrink: 0,
    alignItems: 'center',
  },

  marginRow: {
    marginBottom: 5,
    color: globalConfigurableData.primaryTextColor1,
  },
  valText: {
    color: globalConfigurableData.primaryTextColor1,
  },

  liquidityBlock: {
    marginTop: 15,
    paddingHorizontal: 15,
  },
});
